import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import CloseButton from "../CloseButton/CloseButton.vue";
import SharedButton from "../SharedButton.vue";
import { animationDurationMs } from "../../../services/services.modal";


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    ifShowIsOpen: { type: Boolean, default: true },
    wide: { type: Boolean },
    fullMaxHeight: { type: Boolean },
    narrow: { type: Boolean },
    closeActionButton: { type: Boolean },
    closeActionButtonText: { default: "Ok" },
    headline: null,
    noScrollbar: { type: Boolean },
    noBodyPadding: { type: Boolean },
    mountTo: { default: "body" }
  },
  emits: ["closing", "closed"],
  setup(__props: any, { expose, emit }) {

const props = __props as { ifShowIsOpen: boolean, wide?: boolean, fullMaxHeight?: boolean, narrow?: boolean, closeActionButton?: boolean, closeActionButtonText: string, headline?: string, noScrollbar?: boolean, noBodyPadding?: boolean, mountTo: string }




const slideIn = ref(true);
watch(
	() => props.ifShowIsOpen,
	(newVal) => (slideIn.value = newVal)
);

const close = (triggeredBy: string | null = null) => {
	slideIn.value = false;
	emit("closing", triggeredBy);
	setTimeout(() => {
		emit("closed", triggeredBy);
	}, animationDurationMs);
};
expose({ close });

return { __sfc: true,props, emit, slideIn, close, CloseButton, SharedButton, animationDurationMs }
}

})